import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const Title = ({ textColor, backgroundColor, backgroundOpacity, children, ...rest }) => {
  const theme = useTheme();

  // Direct mapping from provided theme:
  const paletteMapping = {
    primary: theme.palette.primary.main, // PRIMARY
    secondary: theme.palette.secondary.main, // SECONDARY
    textPrimary: theme.palette.text.primary, // TEXT
    textSecondary: theme.palette.text.secondary, // LIGHT TEXT
    complementary: theme.palette.background.paper, // COMPLEMENTARY
  };

  // const headerBackgroundColor = paletteMapping[backgroundColor] ?? backgroundColor ?? "#ffffff00";
  const headerTextColor = paletteMapping[textColor] ?? textColor ?? theme.palette.text.primary;
  // const headerBottomBorderColor = bottomBorderColor ? paletteMapping[bottomBorderColor] ?? bottomBorderColor : null;

  if(!backgroundColor) backgroundOpacity = 0

  return (
    <h1
      {...rest}
      style={{
        color: headerTextColor
      }}
    >
      {children}
    </h1>
  );
};

Title.propTypes = {
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundOpacity: PropTypes.string,
  children: PropTypes.object
};

export default Title;
